<app-loader *ngIf="isDisabled"></app-loader>
<form name="EmpSummaryForm" (ngSubmit)="Validate(EmpSummaryForm)" #EmpSummaryForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Date wise summary <span class="fw-bold">({{this.SiteName}})</span></label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="Stick-Header">
                    <div
                        style="height: 2.2rem;width: fit-content;justify-self:center;color:white;background:var(--success)">
                        <div class="row no-gutters cursor-pointer text-start align-items-center px-2">
                            <div class="col-auto" (click)="changeEmp(-1)">
                                <i class="bi bi-chevron-left"></i>
                            </div>
                            <div class="col">
                                <h4>{{this.dateKeys[this.Index]}}</h4>
                            </div>
                            <div class="col-auto" (click)="changeEmp(1)">
                                <i class="bi bi-chevron-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="summarydata"
                    class="customeDatatable table table-bordered" name="summarydata" style="font-size:xx-small">
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button type="submit" class="btn btn-sm btn-primary" [disabled]="isDisabled" *ngIf=" this.common.PageRight.IsEdit"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>